import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useTheme,
  VStack
} from '@chakra-ui/react';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPaymentAgain: () => void;
  onAnotherCard: () => void;
  title: string;
  description: string;
  apiErrorText?: string;
}

const ErrorModal = ({
  isOpen,
  onClose,
  title,
  onPaymentAgain,
  onAnotherCard,
  description,
  apiErrorText = ''
}: ErrorModalProps) => {
  const {
    colors: {
      palette: {
        components: { paymentErrorModal }
      }
    }
  } = useTheme();

  const handlePaymentAgain = () => {
    onClose();
    onPaymentAgain();
  };

  const handleAnotherCard = () => {
    onClose();
    onAnotherCard();
  };

  const errorText = apiErrorText.length ? ` (${apiErrorText})` : '';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={{ base: '3xl', md: '3xl', lg: '3xl', '3xl': '6xl' }}
      isCentered
    >
      <ModalOverlay bg={paymentErrorModal.overlayBackground} opacity='0.1' />
      <ModalContent
        overflow='hidden'
        margin='15px'
        bg='transparent'
        boxShadow='none'
      >
        <ModalBody p={0}>
          <Flex gap={0} flexDirection={{ base: 'column', md: 'row' }}>
            <VStack
              align='center'
              gap={0}
              flex='1'
              px={{ base: '30px', md: '40px', '2xl': '65px' }}
              pt={{ base: '0', md: '30px', lg: '40px', '2xl': '65px' }}
              pb={{ base: '60px', md: '40px' }}
            >
              <Text
                fontSize={{ base: '32px', md: '42px', lg: '60px' }}
                color={paymentErrorModal.titleColor}
                textAlign='center'
                mb={{ base: '25px', md: '35px', xl: '42px' }}
              >
                {title}
              </Text>
              <Text
                fontSize={{ base: '18px', md: '24px', lg: '28px' }}
                color={paymentErrorModal.descriptionColor}
                textAlign='center'
                maxWidth='700px'
                lineHeight={1.3}
              >
                Your payment was not processed
              </Text>
              <Text
                fontSize={{ base: '18px', md: '24px', lg: '28px' }}
                color={paymentErrorModal.descriptionColor}
                textAlign='center'
                maxWidth='700px'
                lineHeight={1.3}
              >
                {errorText}
              </Text>
              <Text
                fontSize={{ base: '18px', md: '24px', lg: '28px' }}
                color={paymentErrorModal.descriptionColor}
                textAlign='center'
                maxWidth='700px'
                lineHeight={1.3}
              >
                {description}
              </Text>

              <Flex
                w='100%'
                gap={{ base: '20px', md: '40px' }}
                justifyContent='center'
                alignItems='center'
                mt={{ base: '30px', sm: '40px', xl: '60px' }}
                flexDirection={{ base: 'column', md: 'row' }}
              >
                <Button
                  w='180px'
                  height='45px'
                  variant='solid'
                  colorScheme='black'
                  fontSize='14px'
                  fontWeight='bold'
                  onClick={handlePaymentAgain}
                >
                  Try Again
                </Button>

                <Button
                  w='180px'
                  height='45px'
                  variant='outline'
                  colorScheme='black'
                  fontSize='14px'
                  fontWeight='bold'
                  onClick={handleAnotherCard}
                >
                  Another Card
                </Button>
              </Flex>
            </VStack>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ErrorModal;
